import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-846f5114")

_pushScopeId("data-v-846f5114")
const _hoisted_1 = /*#__PURE__*/_createVNode("label", { style: {"color":"#F56C6C","margin-right":"4px"} }, "*", -1)
const _hoisted_2 = { class: "display-flex info-item-bottom" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_4 = {
  key: 0,
  style: {"color":"#f56c6c"},
  class: "font-size12px"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_distributor_table = _resolveComponent("distributor-table")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_dialog_shell, {
      title: _ctx.$wordList.TabelVersionTitleAdd,
      onClose: _ctx.close,
      onSubmit: _ctx.submit
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form, {
          "label-position": _ctx.$formLabelPosition,
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "firmwareDialog"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelVersionLog,
              prop: "Log"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Log,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Log = $event)),
                  "auto-complete": "off",
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelVersionVersion,
              prop: "Version"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Version,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Version = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.TabelVersionUrl,
              prop: "Url"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.Url,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.Url = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _hoisted_1,
            _createVNode("label", null, _toDisplayString(_ctx.$wordList.TabelVersionManage), 1),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.formData.AllManage,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.AllManage = $event)),
                  "true-label": '1',
                  "false-label": '0'
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.TabelVersionAllDistrict) + "(" + _toDisplayString(_ctx.$wordList.IncludeFutureDis) + ") ", 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.formData.AllManage==='0')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("div", _hoisted_2, [
                        _createVNode(_component_el_input, {
                          placeholder: _ctx.$wordList.UserSearchLabelAccount,
                          class: "width200px margin-right10px",
                          modelValue: _ctx.tempDisAccount,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.tempDisAccount = $event))
                        }, null, 8, ["placeholder", "modelValue"]),
                        _createVNode(_component_cus_button, { onClick: _ctx.searchAccount }, {
                          default: _withId(() => [
                            _hoisted_3,
                            _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createVNode(_component_distributor_table, {
                        "select-item": _ctx.formData.ManageID,
                        account: _ctx.disAccount,
                        onUpdateSelectData: _ctx.updateSelectData
                      }, null, 8, ["select-item", "account", "onUpdateSelectData"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.isRequiredChooseTips)
              ? (_openBlock(), _createBlock("label", _hoisted_4, _toDisplayString(_ctx.$wordList.RuleAdministratorChoose), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label-position", "model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "onClose", "onSubmit"])
  ]))
})